import request from "@/utils/request";

export const requestMintClaimerSignature = async (data: {
  walletAddress: string;
  validatorTokenId: string;
  lieutenantAddr: string;
}): Promise<{
  mintId: string;
  signedMessage: string;
  message: {
    score: number;
    role: number;
  };
}> => {
  // @ts-ignore
  return await request.rpc("claimer/requestMintClaimerSignature", data, {
    endpoint: "network",
  });
};

export const getTxStatusfromMintId = async (data: {
  mintId: string;
}): Promise<{
  txHash: string;
  status: "offchain" | "pending" | "failed" | "success";
}> => {
  // @ts-ignore
  return await request.rpc("claimer/getTxStatusfromMintId", data, {
    endpoint: "network",
  });
};

export const mintByClaimer = async (data: {
  walletAddress: string;
  validatorTokenId: string;
  lieutenantAddr: string;
  depositChainId: number;
  depositTransactionHash: string;
}): Promise<{
  mintId: string;
  result: string;
  message: {
    score: number;
    role: number;
  };
}> => {
  // @ts-ignore
  return await request.rpc("claimer/mintByClaimer", data, {
    endpoint: "network",
  });
};

export const getTxHashfromMintId = async (data: {
  mintId: string;
}): Promise<{
  transactionHash: string;
}> => {
  // @ts-ignore
  return await request.rpc("claimer/getTxHashfromMintId", data, {
    endpoint: "network",
  });
};
